import React, {useMemo, useState, useCallback} from 'react';
import {Button, Form, Input, message} from "antd";
import {checkGuest} from "../../../../api/workplace/document";
import Logo from "../../../../asset/logo/logo.png";
import LoginImg from "../../../../asset/logo/login-img.png";
import IconGooglePlay from "../../../../asset/logo/ggplay.png";
import IconAppstore from "../../../../asset/logo/appstore.png";
import {t} from "i18next";
import {debounce} from "lodash/function";
import {DELAY_DEBOUNCE} from "../../../config-variable/notification";

const GuestFile = props => {
    const [pass, setPass] = useState(false);
    const [iframeContent, setIframeContent] = useState()

    const [form] = Form.useForm()
    const [flag, setFlag] = useState(true)


    useMemo(() => {
        setFlag(false)

        const docToken = localStorage.getItem("docToken")
        if (docToken !== null) {
            const decodeDocToken = JSON.parse(atob(docToken))
            checkGuest({
                fileId: decodeDocToken?.fileId,
                password: decodeDocToken?.password
            }).then(() => {
                setPass(true)
                setIframeContent(<iframe
                    src={`${process.env.REACT_APP_DOC_FILE_API}/external/guests/files/${decodeDocToken?.fileId}?password=${decodeDocToken?.password}`}
                    style={{width: "100%", height: "100%", border: "none"}}
                />)
            }).finally(() => {
                setFlag(true)
            })
        } else
            setFlag(true)
    }, [])


    const onFinish = (value) => {
        checkGuest({
            fileId: props.fileId,
            password: value.password
        }).then(() => {
            localStorage.setItem("docToken", btoa(unescape(encodeURIComponent(JSON.stringify(
                {
                    fileId: props.fileId,
                    password: value.password
                }
            )))))
            setPass(true)
            setIframeContent(<iframe
                src={`${process.env.REACT_APP_DOC_FILE_API}/external/guests/files/${props.fileId}?password=${value.password}`}
                style={{width: "100%", height: "100%", border: "none"}}
            />)
        }).catch(error => {
            message.warning(error.response.data)
        })

    }

    const debouncedAdd = useCallback(
        debounce((form) => {
            form.submit()
        }, DELAY_DEBOUNCE),
        []);

    const handleAdd = () => {
        debouncedAdd(form)
    };

    return (
        <>
            {flag && !pass ?
                <>
                    <div className={"login-page"}>
                        <div className="login-header flex md:justify-between w-full">
                            <img src={Logo} alt="Logo" className={"login-logo"}/>
                        </div>
                        <div
                            className="login-content flex lg:justify-between xl:justify-between 2xl:justify-between md:justify-center items-center">
                            <div className={"hidden md:hidden lg:block md:mx-10 lg:mx-5"}>
                                <h1 className={"font-bold text-white mb-10 text-3xl"}>
                                    <p>{t("tnp.common.file.text1")}</p>
                                    <p>{t("tnp.common.file.text2")}</p>
                                </h1>
                                <h4 className={"font-medium text-white text-sm"}>
                                    <p>{t("tnp.common.file.text3")}</p>
                                    <p>{t("tnp.common.file.text4")}</p>
                                </h4>
                            </div>
                            <div className={"hidden md:hidden lg:hidden xl:block 2xl:block"}>
                                <img src={LoginImg} alt="LoginImg" className={"login-hero"}/>
                            </div>
                            <div className={"flex justify-between items-center md:mx-10 lg:mx-5"}>
                                <div className={"login-form bg-white md:px-11 rounded-2xl"}>
                                    <h1 className={"lg:text-2xl xl:text-3xl 2xl:text-5xl font-bold md:py-5 lg:py-5 xl:py-8 2xl:py-12 m-0"}>
                                        {t("tnp.common.file.text5")}
                                    </h1>
                                    <div className="login-form__inner">
                                        <Form form={form} onFinish={onFinish}>
                                            <Form.Item
                                                name={"password"}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please input your password!',
                                                    },
                                                ]}
                                            >
                                                <Input.Password/>
                                            </Form.Item>
                                            <Button
                                                block
                                                onClick={handleAdd}
                                                className={"rounded-lg text-white transition-all mb-7"}
                                                style={{background: "var(--primary-color-bg)"}}
                                            >
                                                {t("tnp.common.file.text6")}
                                            </Button>
                                            <div className="hide-on-md">
                                    <span className={"text-center block mb-5"}>
                                       {t("tnp.common.file.text7")}
                                    </span>
                                                <div className={"download flex justify-center items-center mb-5"}>
                                                    <div
                                                        className={"download-btn flex justify-center items-center p-1 rounded-md cursor-pointer"}>
                                                        <img src={IconGooglePlay} alt="IconGooglePlay"
                                                             className={"download-icon"}/>
                                                        <div className={"flex-col ml-2"}>
                                                            <div className={"download-text-sm -mb-1"}>
                                                                Download on the
                                                            </div>
                                                            <div className={"text-sm m-0"}>
                                                                Google Play
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className={"download-btn flex justify-center items-center p-1 rounded-md cursor-pointer"}>
                                                        <img src={IconAppstore} alt="IconAppstore"
                                                             className={"download-icon"}/>
                                                        <div className={"flex-col ml-2"}>
                                                            <div className={"download-text-sm -mb-1"}>
                                                                Download on the
                                                            </div>
                                                            <div className={"text-sm m-0"}>
                                                                App Store
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={"copyright flex justify-center items-center"}>
                                                    <span className={"mx-1"}>Dogoo</span>
                                                    <span
                                                        className={"rounded-full copyright-icon flex justify-center items-center"}>c</span>
                                                    <span>2022</span>
                                                </div>
                                            </div>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                : iframeContent}


        </>
    );

};

GuestFile.propTypes = {};

export default GuestFile;
